/**
 * Format a date string to DD/MM/YYYY
 */
export function formatDateDDMMYYYY(dateStr: string | Date): string {
  const date = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Format a date to YYYY-MM-DD (for HTML date inputs)
 */
export function formatDateYYYYMMDD(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Get the first day of the current month in YYYY-MM-DD format
 */
export function getFirstDayOfCurrentMonth(): string {
  const now = new Date();
  return formatDateYYYYMMDD(new Date(now.getFullYear(), now.getMonth(), 1));
}

/**
 * Get the last day of the current month in YYYY-MM-DD format
 */
export function getLastDayOfCurrentMonth(): string {
  const now = new Date();
  return formatDateYYYYMMDD(new Date(now.getFullYear(), now.getMonth() + 1, 0));
}

/**
 * Get the current month date range as { from, to }
 */
export function getCurrentMonthRange(): { from: string; to: string } {
  return {
    from: getFirstDayOfCurrentMonth(),
    to: getLastDayOfCurrentMonth(),
  };
}

/**
 * Get the current year
 */
export function getCurrentYear(): number {
  return new Date().getFullYear();
}

/**
 * Get the current month (1-12)
 */
export function getCurrentMonth(): number {
  return new Date().getMonth() + 1;
}
